import { Injectable } from '@angular/core';
import { MatSnackBar } from "@angular/material/snack-bar";
import * as moment from "moment";

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  constructor(private snackbar: MatSnackBar) { }

  openSnackbar(message: string, type: string, duration?: number): void {
    this.snackbar.open(message, undefined, {
      duration: duration ? duration : 4500,
      panelClass: type,
      horizontalPosition: 'right',
      verticalPosition: 'top'
    });
  }

  sortBy(data: any, validator: string, type = 'ASC'): any {
    if (data && data.length > 0) {
      data.sort((a: any, b: any) => {
        if (a[validator] > b[validator]) {
          return type === 'ASC' ? 1 : -1;
        }

        if (a[validator] < b[validator]) {
          return type === 'ASC' ? -1 : 1;
        }

        return 0;
      });
    }

    return data;
  }

  parseDateFormat(date: string, enableTime = false): string {
    if (date) {
      const format = enableTime ? 'MMM Do - YYYY HH:mm' : 'MMM Do - YYYY';
      return moment(date).format(format);
    } else {
      return '';
    }
  }
}
